//#region components
import { StyledButton } from "components/common";
import useOnViewSalaryDraftDeviation from "./useSalaryDraftDeviationViewInfo";
import { Grid } from "@mui/material";
//#endregion
//#region types
import { TranslationKeys } from "translations";
import { LocalizationHelperInstance } from "utils/helpers";
import { SalaryDraftMainSectionButtonProps } from "models/propTypes/salaryPropTypes";
import cssExports from "theme/styles/main.module.scss";
//#endregion

const SalaryDraftMainSectionButton: React.FC<SalaryDraftMainSectionButtonProps> = (props) => {
  const onDeviationClick = useOnViewSalaryDraftDeviation(props.yearAndMonth);

  return (
    <Grid container direction="row" spacing={1} className={cssExports.titledContainerButtons}>
      <Grid item>
        <StyledButton size="sm" secondary onClick={onDeviationClick}>
          {LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Salary.SeeDeviationReport)}
        </StyledButton>
      </Grid>
    </Grid>
  );
};

export default SalaryDraftMainSectionButton;
